import React, { useContext } from 'react';
import { Select } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';

// Promotes the "building" filter field TicketListContainer already declares
// (containerConfiguration in TicketListContainer.tsx) into a prominent,
// page-level control instead of leaving it buried in the generic filter
// chips row. Reuses the existing filter/refetch wiring — no new fetch.
const OptimizeBuildingFilter = () => {
  const { getFilterOptions, getFilterValues, handleFilter } =
    useContext(InputContext);

  const options = getFilterOptions('building').map((opt) => ({
    label: opt.text,
    value: opt.value,
  }));

  return (
    <Select
      mode="multiple"
      allowClear
      placeholder="All buildings"
      style={{ minWidth: 280, maxWidth: 480 }}
      options={options}
      value={getFilterValues('building')}
      onChange={(values: string[]) => handleFilter('building', values)}
    />
  );
};

export default OptimizeBuildingFilter;
